module.exports = __webpack_public_path__ + "static/img/tstart.0001855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tstart.png
// module id = wS1t
// module chunks = 1